import { Badge } from '@/components/ui/badge';
import { T } from 'gt-react';
import { SpaRequestStatus } from '@erp/shared-types';
import type { StageStatus } from '../mocks/types';

interface SpaStatusBadgeProps {
  status: SpaRequestStatus;
}

export function SpaStatusBadge({ status }: SpaStatusBadgeProps) {
  switch (status) {
    case SpaRequestStatus.Draft:
      return (
        <Badge variant="outline">
          <T context="SPA request status badge">Draft</T>
        </Badge>
      );
    case SpaRequestStatus.PendingApproval:
      return (
        <Badge variant="warning">
          <T context="SPA request status badge">Pending Approval</T>
        </Badge>
      );
    case SpaRequestStatus.InProgress:
      return (
        <Badge variant="default">
          <T context="SPA request status badge">In Progress</T>
        </Badge>
      );
    case SpaRequestStatus.Done:
      return (
        <Badge variant="success">
          <T context="SPA request status badge">Done</T>
        </Badge>
      );
  }
}

interface StageStatusBadgeProps {
  status: StageStatus;
}

export function StageStatusBadge({ status }: StageStatusBadgeProps) {
  switch (status) {
    case 'pending':
      return (
        <Badge variant="outline">
          <T context="Workflow stage status badge">Pending</T>
        </Badge>
      );
    case 'in_progress':
      return (
        <Badge variant="default">
          <T context="Workflow stage status badge">In progress</T>
        </Badge>
      );
    case 'done':
      return (
        <Badge variant="success">
          <T context="Workflow stage status badge">Done</T>
        </Badge>
      );
    case 'failed':
      return (
        <Badge variant="destructive">
          <T context="Workflow stage status badge">Failed</T>
        </Badge>
      );
    case 'skipped':
      return (
        <Badge variant="secondary">
          <T context="Workflow stage status badge">Skipped</T>
        </Badge>
      );
  }
}
